<div class="page-wrapper">
    <div class="page-header flex-row items-center place-content-between">
        @if ((showList$ | async) === false) {
            <app-back-button
                ariaLabel="Back to reports"
                [route]="['..']"
                [queryParams]="{ accountId: passedAccountId$ | async }"
            ></app-back-button>
        }
        <h1 class="page-title flex-auto">{{ pageTitle$ | async }}</h1>
    </div>
    <div class="page-content">
        @if (error$ | async; as error) {
            <app-notification-banner [severity]="NotificationBannerSeverity.ERROR" announcementRole="alert">
                {{ error }}
            </app-notification-banner>
        } @else if (showList$ | async) {
            <div class="flex flex-col gap-3" *ngrxLet="reports$; let reports">
                @if (reports.length > 0) {
                    @for (report of reports; track report) {
                        <a [routerLink]="[report.id]" [queryParams]="{ accountId: passedAccountId$ | async }">{{
                            report.label
                        }}</a>
                    }
                } @else {
                    <div>No reports found</div>
                }
            </div>
        } @else {
            <div id="report"></div>
        }
    </div>
</div>
